import { render, staticRenderFns } from "./view-pending-list.vue?vue&type=template&id=f15abc00&scoped=true&"
import script from "./view-pending-list.vue?vue&type=script&lang=js&"
export * from "./view-pending-list.vue?vue&type=script&lang=js&"
import style0 from "./view-pending-list.vue?vue&type=style&index=0&id=f15abc00&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f15abc00",
  null
  
)

export default component.exports